<template>
  <div class="my-scenes-body">
    <div>
      <div class="my-scenes-filter-box">
        <div class="my-scenes-filter-tab">
          <div class="my-scenes-filter-search">
            <a-input-search
              placeholder="请输入反馈标题搜索"
              v-model="searchVal"
              @search="searchBtn"
            >
              <a-icon type="search" slot="enterButton" />
            </a-input-search>
          </div>
        </div>
        <div class="my-scenes-filter-btn">
          <a-button class="btn-green" @click="feedbackVisible = true"
            >我要反馈</a-button
          >
        </div>
      </div>
      <div class="my-scenes-list">
        <a-table
          :columns="columns"
          :data-source="feedbackData"
          :pagination="pages"
          @change="pageChange"
        >
          <div slot="num" slot-scope="text, record, index">
            {{ index + 1 }}
          </div>
          <div slot="statusName" slot-scope="text, record">
            <span class="my-scenes-status">
              <i v-if="record.statusName == '已回复'" class="yhf"></i>
              <i v-else-if="record.statusName == '待回复'" class="dhf"></i>
              {{ record.statusName }}
            </span>
          </div>
          <div slot="operating" slot-scope="text, record">
            <div class="my-scenes-operating">
              <!-- <a-badge :count="record.status == '1'?0:1" dot> -->
              <span @click="feedbackDetail(record)">详情</span>
              <!-- </a-badge> -->
            </div>
          </div>
        </a-table>
      </div>
    </div>
    <!-- 详情 -->
    <a-modal v-model="detailVisible" title="反馈详情" @cancel="detailCancel">
      <div class="feedback-detail-body">
        <div>
          <span>反馈标题：</span>
          <p>{{ feedbackDetailInfo.questionTitle }}</p>
        </div>
        <div>
          <span>反馈内容：</span>
          <p>{{ feedbackDetailInfo.questionContent }}</p>
        </div>
        <div>
          <span>回复内容：</span>
          <p>{{ feedbackDetailInfo.answerContent }}</p>
        </div>
        <div>
          <span>回复时间：</span>
          <p>{{ feedbackDetailInfo.answerTime }}</p>
        </div>
      </div>
      <div slot="footer">
        <a-button class="btn-gray" @click="detailCancel">取 消</a-button>
        <a-button class="btn-green" @click="detailCancel">确 定</a-button>
      </div>
    </a-modal>
    <!-- 我要反馈 -->
    <a-modal
      v-model="feedbackVisible"
      title="我要反馈"
      @cancel="feedbackCancel"
    >
      <div class="add-feedback-body">
        <div>
          <span>反馈标题：</span>
          <a-input
            placeholder="请填写问题标题"
            v-model="createFeedbackData.questionTitle"
          />
        </div>
        <div>
          <span>反馈内容：</span>
          <a-textarea
            placeholder="请描述您要反馈的问题，我们将尽快给您回复"
            v-model="createFeedbackData.questionContent"
          />
        </div>
      </div>
      <div slot="footer">
        <a-button class="btn-gray" @click="feedbackCancel">取 消</a-button>
        <a-button class="btn-green" @click="submitFeedback">提 交</a-button>
      </div>
    </a-modal>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    dataIndex: "num",
    key: "num",
    scopedSlots: { customRender: "num" },
  },
  {
    title: "反馈标题",
    dataIndex: "questionTitle",
    key: "questionTitle",
    ellipsis: true,
    width: 600,
  },
  {
    title: "提交时间",
    dataIndex: "questionTime",
    key: "questionTime",
  },
  {
    title: "状态",
    dataIndex: "statusName",
    key: "statusName",
    scopedSlots: { customRender: "statusName" },
  },
  {
    title: "操作",
    dataIndex: "operating",
    key: "operating",
    scopedSlots: { customRender: "operating" },
  },
];

import { getFeedbackList, createFeedback } from "@/api/interactive";
export default {
  data() {
    return {
      feedbackData: [],
      columns,
      pages: {
        showSizeChanger: true,
        showQuickJumper: true,
        current: 1,
        defaultPageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 项`,
      },
      detailVisible: false,
      feedbackVisible: false,
      searchVal: "",
      psge: {
        size: 10,
        current: 1,
      },
      createFeedbackData: {
        questionTitle: "",
        questionContent: "",
      },
      feedbackDetailInfo: "",
    };
  },
  mounted() {
    this.loadGetFeedbackList();
  },
  methods: {
    loadGetFeedbackList() {
      let data = {
        keywords: this.searchVal,
      };
      getFeedbackList(this.psge, data).then((res) => {
        this.feedbackData = res.data.records;
        this.pages.total = res.data.total;
        let obj = {
          index: 1,
          num: res.data.total,
        };
        this.$emit("num", obj);
      });
    },
    searchBtn() {
      this.loadGetFeedbackList();
    },
    pageChange(e) {
      this.psge.current = e.current;
      this.pages.current = e.current;
      this.loadGetFeedbackList();
    },
    submitFeedback() {
      let data = this.createFeedbackData;
      if (!data.questionTitle) {
        this.$message.warning("请填写反馈标题");
        return;
      }
      if (!data.questionContent) {
        this.$message.warning("请描反馈内容");
        return;
      }
      createFeedback(data).then(() => {
        this.loadGetFeedbackList();
        this.feedbackVisible = false;
        this.createFeedbackData = {
          questionTitle: "",
          questionContent: "",
        };
      });
    },
    detailCancel() {
      this.detailVisible = false;
    },
    feedbackDetail(val) {
      this.feedbackDetailInfo = val;
      this.detailVisible = true;
    },
    feedbackCancel() {
      this.feedbackVisible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.my-scenes-body {
  background: #f5f5f5;
  height: 100%;
  overflow-y: auto;
  > div {
    width: 1240px;
    margin: 0 auto;
  }
  .my-scenes-filter-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .my-scenes-filter-tab {
      display: flex;
      align-items: center;
      .my-scenes-filter-search {
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        overflow: hidden;
      }
    }
    .my-scenes-filter-btn {
      display: flex;
      align-items: center;
      > button {
        margin-right: 16px;
      }
    }
  }
  .my-scenes-list {
    background: #fff;
    margin-top: 24px;

    .my-scenes-operating {
      display: flex;
      > span {
        cursor: pointer;
        color: #1abc9c;
        margin-right: 20px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
.my-scenes-status {
  display: flex;
  align-items: center;
  > i {
    width: 6px;
    height: 6px;
    background: #bfbfbf;
    border-radius: 50%;
    margin-right: 8px;
    &.yhf {
      background: #52c41a;
    }
    &.dhf {
      background: #bfbfbf;
    }
  }
}
.feedback-detail-body {
  > div {
    display: flex;
    margin-bottom: 24px;
    > span {
      width: 70px;
      line-height: 22px;
      color: #8c8c8c;
    }
    > p {
      flex: 1;
      line-height: 22px;
      text-align: justify;
      color: #262626;
    }
  }
}
.add-feedback-body {
  > div {
    display: flex;
    margin-bottom: 24px;
    > span {
      width: 70px;
      line-height: 32px;
    }
    input {
      flex: 1;
    }
    textarea {
      flex: 1;
      height: 120px;
    }
  }
}
</style>
<style>
.my-scenes-filter-search input {
  width: 280px !important;
  height: 32px;
  background: #ffffff;
  border: none;
  border-radius: 2px;
}
.my-scenes-filter-search button {
  background: #d9d9d9 !important;
  border-color: #d9d9d9 !important;
  color: #8c8c8c !important;
  box-shadow: none;
  border-radius: 0;
}
.my-scenes-list th,
.my-scenes-list td {
  border-color: #f0f0f0 !important;
}
.ant-table-pagination.ant-pagination {
  margin: 16px;
}
</style>
